import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-medium text-secondary-600 uppercase tracking-wider">常见问题</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
            你关心的，都在这里
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            快速了解麻豆传媒的常见疑问
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFAQ(item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openId === item.id ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg text-foreground-400"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === item.id ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}